export default class PontoFocal {
  document = {
    value: '',
    mask: '###.###.###-##',
    required: true,
    state: null
  }
  nome = {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
  dataNascimento = {
    value: '',
    mask: '##/##/####',
    required: false,
    state: null
  }
  email = {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  }
  telefone = {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  }
  cargo = {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/person/components/add/pontofocal-form.js